// Used to determine what side of the view the Drawer appears from.
export enum DrawerOrigin {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
}

// Used to determine the wrapper size of the Drawer implementation.
// See `drawerSizes` below for each actual size value.
export enum DrawerSize {
  Slim = 'slim',
  Wide = 'wide',
  Full = 'full',
}

export type DrawerSizeType = string | number

export interface DrawerContentProps {
  drawerOrigin: DrawerOrigin
  drawerSize: keyof DrawerSizeVariations
}

export type DrawerSizeVariations = {
  [key in DrawerSize]: DrawerSizeType
}

// These define the Drawer's content wrapper size.
// If any size type needs its size adjusted, do it here.
export const drawerSizes = {
  slim: 360,
  wide: 500,
  full: 'calc(100vh - 20px)',
} as const satisfies DrawerSizeVariations
